import {
  StyledTitleContainer,
  StyledTitleBox,
  StyledStarBox,
  StyledTitle,
  StyledSpecialTitle,
} from "./MainTitle.styles";

export interface MainTitleProps {
  suffix: string; // 後綴文字，例如「素養題」或「素養出題」
  size?: "large" | "medium";
}

const MainTitle = ({ suffix, size = "large" }: MainTitleProps) => {
  return (
    <StyledTitleContainer>
      <StyledTitleBox>
        <StyledStarBox>
          <img src="/landingPage/star.svg" alt="star" width={48} height={48} />
        </StyledStarBox>
        <StyledTitle variant="h1" data-after="南一" size={size}>
          南一
        </StyledTitle>
      </StyledTitleBox>
      <StyledTitleBox>
        <StyledSpecialTitle variant="h1" data-after="AI" size={size}>
          AI
        </StyledSpecialTitle>
        <StyledTitle variant="h1" data-after={suffix} size={size}>
          {suffix}
        </StyledTitle>
      </StyledTitleBox>
    </StyledTitleContainer>
  );
};

export default MainTitle;
